<!--
 * @Desc: 校园新闻
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-07 10:13:10
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="school-news">
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/schoolNews-title.png"
                    />
                </div>
                <div class="title-more" @click="toMore()">
                    了解更多
                    <img class="thu" src="../../../public/statics/images/arr.png">
                </div>
            </div>
            <div class="news-hold">
                <div class="news-one">
                    <div class="news-item" v-if="listData && listData.article" @click="toDetail(listData.article[0])">
                        <img class="thu" :src="$adddom(listData.article[0].thumb)">
                        <div class="desc ellipsis1">{{ listData.article[0].title }}</div>
                    </div>
                </div>
                <div class="news-list" v-if="listData && listData.article">
                    <div class="news-item" v-if="idx > 0 && idx <6" v-for="(item,idx) in listData.article" :key="idx" @click="toDetail(item)">
                        <img class="thu" :src="$adddom(item.thumb)">
                        <div class="desc ellipsis1">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            };
        },
        computed: {
        },
        props:['listData'],
        watch:{
            'listData':function(){
            }
        },
        created: function () {
        },
        methods: {
            // 跳转更多
            toMore(){
                // console.log(this.listData.url)
                // console.log(this.listData.id)
                this.$toPath(this.listData.url,{
                    active:this.listData.id
                })
            },
            /**
             * @name: 跳转详情
             * @param {*} item
             * @return {*}
             * @desc: 跳转详情
             */        
            toDetail(item){
                console.log(item)
                this.$toPath('/NewsDetail?active='+this.listData.id+'&id=' +item.id)
            },
        },
    }
</script>

<style scoped>
.school-news{
    width: 100%;
    height: 702px;
    background: #f0f2f5;
}
.school-news .container {
    padding-top: 110px;
}
.school-news .title-hold .title::after{
    width: 114px;
    height: 28px;
    background: url(../../../public/statics/images/Index/schoolNews-desc.png);
}
.school-news .container .news-hold{
    margin-top: 30px;
    position: relative;
    display: flex;
    padding: 20px;
}
.school-news .container .news-hold::after{
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 1200px;
    height: 165px;
    background: #F2F9FF;
}
.school-news .news-item{
    width: 244px;
    height: 185px;
    position: relative;
}
.school-news .news-item .thu{
    height: 100%;
    object-fit: cover;
}
.school-news .news-item .desc{
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    line-height: 36px;
    background: linear-gradient(270deg, rgba(223,47,37,0.58) 0%, #DE2F25 100%);
    box-shadow: 0px 12px 24px 0px rgba(0,0,0,0.08);
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    padding: 0 15px;
}
.school-news .news-one{
    position: relative;
    z-index: 2;
    margin-left: 3px;
}
.school-news .news-one .news-item{
    width: 636px;
    height: 382px;
    margin-right: 15px;
}
.school-news .news-list{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
}
.school-news .news-list .news-item:nth-child(n+3){
    margin-top: 12px;
}
.school-news .news-list .news-item:nth-child(odd){
    margin-right: 15px;
}
</style>
